import ScheduleMobilePage from "./ScheduleMobilePage";

export default ScheduleMobilePage;
